import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type ReminderParamsChangePayload = {
  modification?: number;
  status?: number;
  low_bg_threshold?: number;
  high_bg_threshold?: number;
  site_change_days?: number;
};

export type ReminderParamsChangeEvent = {
  modification?: number;
  status?: number;
  lowBgThreshold?: number;
  highBgThreshold?: number;
  siteChangeDays?: number;
};

const reminderParamsChangeSchema = z.object({
  modification: cz.permissive(z.number()),
  status: cz.permissive(z.number()),
  low_bg_threshold: cz.permissive(z.number()),
  high_bg_threshold: cz.permissive(z.number()),
  site_change_days: cz.permissive(z.number()),
});

export const LID_PARAM_REM_SETTINGS = {
  value: 0x61,
  name: "Reminder Parameter Change Event",
  format: "bb..hhb.......",
  fields: ["modification", "status", "low_bg_threshold", "high_bg_threshold", "site_change_days"],
  postprocess: rec => ({
    ...rec,
    lowBgThreshold: rec.low_bg_threshold,
    highBgThreshold: rec.high_bg_threshold,
    siteChangeDays: rec.site_change_days,
  }),
  schema: reminderParamsChangeSchema,
} as const satisfies TandemEventDefinition<ReminderParamsChangePayload, ReminderParamsChangeEvent>;
